import { render, staticRenderFns } from "./OpDischargeTransferASAM.vue?vue&type=template&id=6c9afed5"
import script from "./OpDischargeTransferASAM.vue?vue&type=script&lang=js"
export * from "./OpDischargeTransferASAM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports